import { Box, Text, FillPreview } from '@wix/design-system';
import t__default from 'react';
import { ColorPicker } from './color-picker.js';
import { SWATCH_TOGGLE } from './data-hooks.js';
import { ColorPickerLiveSiteColorHint } from './live-site-color-hint.js';
import '../common/color-swatches.js';
import '../../RevertSmall-778c3822.js';
import 'classnames';
import 'ricos-context';
import '../../style-inject.es-e7b07dd7.js';
import '../common/data-hooks.js';

const ToggledColorPicker = ({
  label,
  color,
  userColors,
  onChange,
  onNewColorAdded,
  onToggle,
  isExpanded,
  dataHook,
  showColorPicker,
  colorPickerClassName,
  showResetButton,
  defaultColor,
  showLiveSiteHint
}) => {
  return /* @__PURE__ */ t__default.createElement("div", { "data-hook": dataHook }, /* @__PURE__ */ t__default.createElement(Box, { align: "space-between", marginBottom: "SP1", marginTop: "SP1", verticalAlign: "middle" }, /* @__PURE__ */ t__default.createElement(Text, { size: "small" }, label), /* @__PURE__ */ t__default.createElement(Box, { width: "24px" }, /* @__PURE__ */ t__default.createElement(
    FillPreview,
    {
      content: void 0,
      fill: color || defaultColor,
      onClick: onToggle,
      dataHook: SWATCH_TOGGLE
    }
  ))), isExpanded ? /* @__PURE__ */ t__default.createElement(t__default.Fragment, null, showLiveSiteHint && /* @__PURE__ */ t__default.createElement(ColorPickerLiveSiteColorHint, null), /* @__PURE__ */ t__default.createElement(
    ColorPicker,
    {
      userColors,
      color,
      onChange,
      onNewColorAdded,
      showColorPicker,
      colorPickerClassName,
      showResetButton
    }
  )) : null);
};

export { ToggledColorPicker };
//# sourceMappingURL=toggled-color-picker.js.map
